import Axios from '@/packages/axios/Axios';

export default {
  actions: {
    async authenticated(context) {
      await context.dispatch('fetchClient');
    },
    async fetchClient(context) {
      await Axios.get('/v1/client').then((response) => {
        context.commit('SET_CLIENT', response.data);
      });
    },
  },
  getters: {
    client(state) {
      return state.client;
    },
  },
  mutations: {
    SET_CLIENT(state, newClient) {
      const lState = state;
      lState.client = newClient;
    },
  },
  state: {
    client: undefined,
  },
};
